<template>
  <div class="v-store">
    <div class="v-store__wrapper">
      <div class="shop__header-mobile">
        <div class="v-store__filter-toggle" @click="toggleFilter" v-html="filterToggleText"></div>
          <div class="v-store__sorting v-store__sorting--mobile">
            <!-- <span>Sort By:</span> -->
            <select v-model="sortValue">
              <option value="popular">Default</option>
              <option value="price-asc">Lowest Price</option>
              <option value="price-desc">Highest Price</option>
            </select>
            <i class="fas fa-chevron-down"></i>
          </div>        
      </div>
      <FilterPanel
        :showFilter="showFilter"
        :brands="filteredBrands"
        :categories="structuredCategories"
        :tags="tags"
        @filter="setFilterParams"
        @display="setDisplayParams"
      />
      <main>
        <div class="v-store__products-title">
          
          <div v-if="activeCategory" class="h2"><h2>{{ activeCategory.name }}</h2></div>
          <div
            v-if="activeCategory && activeCategory.description.length"
            style="margin-bottom: 1em; cursor: pointer; text-decoration: underline;"
            @click="toggleCategoryDescription"
          >{{ showCategoryDescription ? 'Read Less' : `Read more` }}</div>
          <div
            v-if="activeCategory && activeCategory.description.length"
            class="v-store__category-description-wrapper"
            :style="`height: ${categoryDescriptionHeight}px; margin-bottom: 1em;`"
          >
            <div
              class="editable-content"
              ref="categoryDescription"
              style="display: inline-block"    
              v-html="activeCategory.description"
            ></div>
          </div>
          <div class="b" v-if="activeCategories.length">Selected Categories: <span v-for="cat, i in activeCategoryNames">{{ cat }}<span v-if="activeCategoryNames.length > 1 && i !== activeCategoryNames.length - 1">, </span></span></div>
          <div class="b" v-if="activeTags.length">Selected Tags: <span v-for="tag, i in activeTagNames">{{ tag }}<span v-if="activeTagNames.length > 1 && i !== activeTagNames.length - 1">, </span></span></div>
        </div>
        <div class="v-store__products-header">
          <div class="spacer"></div>
          <!-- <div class="v-store__sorting v-store__sorting--desktop" style="padding-left: 30px;">
            <input type="checkbox" id="show-sku" v-model="showSku" />
            <label for="show-sku">Show SKU</label>
          </div>              -->
          <div v-if="false" class="v-store__sorting v-store__sorting--desktop">
            
            <!-- <span>Products per page:</span> -->
            <select v-model="productsPerPage">
              <option value="15">15 products per page</option>
              <option value="30">30 products per page</option>
              <option value="60">60 products per page</option>
            </select>
          </div>          
          <div class="v-store__sorting v-store__sorting--desktop" style="padding-left: 30px;">
            <!-- <span>Sort By:</span> -->
            <select v-model="sortValue">
              <option value="popular">Most Popular</option>
              <option value="price-asc">Lowest Price</option>
              <option value="price-desc">Highest Price</option>
            </select>
          </div>
       
        </div>
        <div class="v-store__products">
          <div class="v-store__loader" v-if="isLoading"><i class="fas fa-spinner fa-pulse"></i></div>
          <div
            v-for="product in filteredProducts.slice((this.currentPage - 1) * this.productsPerPage, this.currentPage * productsPerPage)"
            class="v-store__product"
            :key="product.id"
          >
            <ProductTile
              :slug="product.slug"
              :product-id="product.id"
              :image="product.image"
              :brand="product.brand"
              :name="product.name"
              :sku="product.sku"
              :show-sku="showSku"
              :price="product.requires_clinical_assessment ? false : product.price"
              :sale-price="product.sale_price"
              :regular-price="product.regular_price"
              :price-html="product.price_html"
              :is-on-sale="!isPartner && product.is_on_sale"
              :host="host"
              :has-variants="product.has_variants"
              :qty="getItemQty(product.id)"
              :search-priority="product.searchPriority"
              :tags="product.tags"
              @addToCart="addItemToCart(product.id, 1)"
              @removeFromCart="removeItemFromCart(product.id)"
              @updateItem="updateItemInCart"
            />
          </div>
        </div>
      </main>
    </div>
    <div class="v-store__pagination">
      <div>{{ resultsString }}</div>
      <button @click="goToPage(currentPage - 1)" :disabled="currentPage === 1"><i class="fas fa-chevron-left"></i></button>
      <!-- <span>{{ paginationString }}</span> -->
      <span v-if="pages <= 6">
        <span 
          class="v-store__pagination-number" 
          :class="{ 'v-store__pagination-number--active': page === currentPage }" 
          v-for="page in pages" 
          @click="goToPage(page)"
        >{{ page }}</span>
      </span>
      <span v-if="pages > 6">
        <span 
          v-if="currentPage < (pages - 2)"
          class="v-store__pagination-number" 
          :class="{ 'v-store__pagination-number--active': page === currentPage }" 
          v-for="page in [ currentPage, currentPage + 1, currentPage + 2]" 
          @click="goToPage(page)"
        >{{ page }}</span>
        <span>...</span>
        <span 
          class="v-store__pagination-number" 
          :class="{ 'v-store__pagination-number--active': page === currentPage }" 
          v-for="page in [pages - 2, pages - 1, pages]" 
          @click="goToPage(page)"
        >{{ page }}</span>
      </span>

      <button @click="goToPage(currentPage + 1)" :disabled="currentPage === pages"><i class="fas fa-chevron-right"></i></button>
    </div>

    <div class="v-store__success-modal" v-show="showSuccessModal" @click="closeSuccessModal()">
      <div class="v-store__success-modal-inner" @click.stop>
        <h2>Item added to cart successfully!</h2>
        <button class="button button--secondary" @click="closeSuccessModal()">Keep Shopping</button>
        <a class="button button--secondary" href="/cart">View Cart</a>
        <a class="button" href="/checkout">Checkout Now</a>
        <button class="v-store__success-modal-close" @click="closeSuccessModal()"><i class="fas fa-times"></i></button>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import FilterPanel from './components/FilterPanel'
import ProductTile from './components/ProductTile'
import sortBy from 'lodash/sortBy'
import uniqBy from 'lodash/uniqBy'
import find from 'lodash/find'
import intersection from 'lodash/intersection'
export default {
  components: { FilterPanel, ProductTile },

  data () {
    return {
      host: null,
      categories: window.categories,
      isError: false,
      isLoading: false,
      products: window.products,
      productsPerPage: 24,
      categoryDescriptionHeight: 0,
      currentPage: 1,

      showCategoryDescription: false,
      showFilter: false,
      sortValue: 'popular',
      
      showSalesOnly: false,
      showSku: false,

      activeBrands: [],
      activeCategories: [],
      activeTags: [],
      activeSearchTerm: '',
      activePriceHigh: 1000,
      activePriceLow: 0,

      cart: {},
      showSuccessModal: false,

      isPartner: window.is_partner
    }
  },

  computed: {
    activeCategoryNames () {
      if (this.activeCategories.length) {
        return this.activeCategories.map(cat => {
          return this.categories.find(category => category.slug === cat).name
        })
      } else {
        return []
      }
    },

    activeTagNames () {
      if (this.activeTags.length) {
        return this.activeTags.map(tag => {
          return this.tags.find(t => t.slug === tag).name
        })
      } else {
        return []
      }
    },

    activeCategory () {
      if (this.activeCategories.length !== 1) return null
      return this.categories.find(cat => cat.slug === this.activeCategories[0])
    },

    brands () {
      // TODO get category product count
      let brands = []
      this.products.forEach(product => {
        if (product.brand) {
          brands.push({ name: product.brand.trim(), value: product.brand.trim().toLowerCase() })
        }
      })
      return sortBy(uniqBy(brands, 'name'), 'value')
    },

    filteredBrands () {
      let filteredBrands = []
      if (!this.activeCategory) return this.brands
      this.brands.forEach(brand => {
        if (this.productsFilteredByCategory.map(product => product.brand?.trim()).includes(brand.name)) {
          filteredBrands.push({ name: brand.name, disabled: false, value: brand.value })
        } else {
          filteredBrands.push({ name: brand.name, disabled: true, value: brand.value })
        }
      })
      return filteredBrands
    },

    tags () {
      let tags = []
      this.products.forEach(product => {
        product.tags.forEach(tag => {
          const name = tag.replace(/-/g, ' ').replace(/\b\w/g, l => l.toUpperCase())
          tags.push({ name, slug: tag})
        })
      })
      return sortBy(uniqBy(tags, 'name'), 'name')
    },

    productsFilteredByCategory () {
      this.currentPage = 1
      if (!this.activeCategories.length) return this.products
      return this.products.filter(product => {
        return this.activeCategories.length && intersection(product.categories, this.activeCategories).length
      })
    },

    filteredProducts () {
      this.currentPage = 1
      let filteredProducts = this.products.filter(product => {
        product.searchPriority = 999
        let showProduct = false

        // If no filtering is set
        if (this.activeBrands.length === 0 && this.activeCategories.length === 0) {
          showProduct = true
        }

        // Brand
        if (this.activeBrands.length && this.activeBrands.includes(product.brand.trim().toLowerCase())) {
          showProduct = true
        }

        // Category
        if (this.activeCategories.length && intersection(product.categories, this.activeCategories).length) {
          showProduct = true
        }

        if (this.activeBrands.length && !this.activeBrands.includes(product.brand.trim().toLowerCase())) {
          showProduct = false
        }

        // Tag
        if (showProduct && this.activeTags.length) {
          if (!intersection(product.tags, this.activeTags).length) {
            showProduct = false
          }
        }       

        // Price
        let price = parseFloat(product.price)
        if (!isNaN(price) && (price < this.activePriceLow) || (price > (this.activePriceHigh === 1000 ? Number.POSITIVE_INFINITY : this.activePriceHigh))) {
          showProduct = false
        }

        if (this.showSalesOnly && !product.is_on_sale) {
          showProduct = false
        }

        return showProduct
      })

      let productMatchingSKU = null
      if (this.activeSearchTerm.length !== 0) {

        filteredProducts = filteredProducts.filter(product => {
          
          let searchFilter = false

          if (this.activeSearchTerm.toLowerCase() === product.sku?.toLowerCase()) {
            productMatchingSKU = product
          }

          if (intersection(product.name?.toLowerCase().split(/[ -]/), this.activeSearchTerm.toLowerCase().split(/[ -]/)).length) {
            searchFilter = true
            product.searchPriority =  product.searchPriority > 1 ? 1 : product.searchPriority
          }

          if (intersection(product.brand?.toLowerCase().split(/[ -]/), this.activeSearchTerm.toLowerCase().split(/[ -]/)).length) {
            searchFilter = true
            product.searchPriority =  product.searchPriority > 3 ? 3 : product.searchPriority
          }

          if (intersection(product.description?.toLowerCase().split(/[ -]/), this.activeSearchTerm.toLowerCase().split(/[ -]/)).length) {
            searchFilter = true
            product.searchPriority =  product.searchPriority > 4 ? 4 : product.searchPriority
          }

          if (intersection(product.short_description?.toLowerCase().split(/[ -]/), this.activeSearchTerm.toLowerCase().split(/[ -]/)).length) {
            searchFilter = true
            product.searchPriority =  product.searchPriority > 4 ? 4 : product.searchPriority
          }

          if (intersection(product.sku?.toLowerCase().split(/[ -]/), this.activeSearchTerm.toLowerCase().split(/[ -]/)).length) {
            searchFilter = true
            product.searchPriority =  product.searchPriority > 4 ? 4 : product.searchPriority
          }

          product.tags.forEach(tag => {
            if (tag?.toLowerCase().includes(this.activeSearchTerm.toLowerCase().trim())) {
              searchFilter = true
              product.searchPriority =  product.searchPriority > 2 ? 2 : product.searchPriority
            }
          })

          return searchFilter
        })
      }
      // If a product matches SKU, only return that product
      if (productMatchingSKU) {
        return [productMatchingSKU]
      }
      if (this.sortValue === 'price-asc') {
        return sortBy(filteredProducts, product => {
          return parseFloat(product.price)
        })
      } else if (this.sortValue === 'price-desc') {
        return sortBy(filteredProducts, product => {
          return parseFloat(product.price)
        }).reverse()
      } else {
        return sortBy(filteredProducts, product => {
          return product.searchPriority
        })
      }
    },
    
    filterToggleText () {
      return this.showFilter ? 'Hide Filters  <i class="fas fa-chevron-up"></i>' : 'Show Filters  <i class="fas fa-chevron-down"></i>'
    },

    pages () {
      return Math.ceil(this.filteredProducts.length / this.productsPerPage)
    },

    paginationString () {
      return `Page ${this.currentPage} of ${this.pages}`
    },

    resultsString () {
      if (this.filteredProducts.length === this.products.length) {
        return 'Showing All Products'
      } else {
        return `${this.filteredProducts.length} Matching Products`
      }
    },

    structuredCategories () {
      let structuredCategories = []
      this.categories.forEach(category => {
        if (category.parent_id === 0) {
          structuredCategories.push(category)
        } else {
          let parent = this.categories.find(cat => {
            if (cat.id === category.parent_id) return cat
          })
          if (parent) {
            parent.expanded = false
            parent.children = parent.children || []
            parent.children.push(category)
          }
        }
      })
      return structuredCategories
    }
  },

  watch: {
    activeCategory () {
      if (this.activeCategory) {
        console.log(Object.assign({}, this.$route.query, { category: this.activeCategory.slug }))
        this.$router.push({ name: 'ShopIndex', query: Object.assign({}, this.$route.query, { category: this.activeCategory.slug })})
      } else {
        console.log(Object.assign({}, this.$route.query, { category: false }))
        this.$router.push({ name: 'ShopIndex', query: Object.assign({}, this.$route.query, { category: false })})
      }
      if (this.$route.query.page) {
        console.log(this.$route.query.page)
        this.currentPage = parseInt(this.$route.query.page)
        console.log(this.currentPage)
      }
      this.activeBrands = []
      this.showFilter = false
      this.showCategoryDescription = false
      this.categoryDescriptionHeight = 0
    },

    currentPage () {
      this.$el.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" })
    },

    activeSearchTerm () {
      this.showFilter = false
      this.showCategoryDescription = false
      this.categoryDescriptionHeight = 0
    },

    // $route () {
    //   if (this.$route.query.page) {
    //     this.currentPage = parseInt(this.$route.query.page)
    //   }
    // }
  },

  created () {
    let host = window.location.host
    if (host.includes('localhost')) {
      this.host = 'novitatech.localhost'
    } else {
      this.host = window.location.host
    }
    // this.host = 'novitatech.com.au'
  },

  mounted () {
    document.body.classList.remove('woocommerce')
    // this.updateProductsPerPage()

    window.addEventListener('resize', e => {
      this.showCategoryDescription = false
      this.categoryDescriptionHeight = 0
      // this.updateProductsPerPage()
    })    

    this.$router.isReady().then(() => {
      if (this.$route.query.page) {
        this.$nextTick(() => {
          this.goToPage(this.$route.query.page)
        })
      }      
    })

    this.fetchCart()
    // this.fetchProducts()
  },

  methods: {
    closeSuccessModal () {
      this.showSuccessModal = false
    },

    getItemQty (id) {
      const item = find(this.cart.items, { 'id': parseInt(id) })
      if (item) console.log(item.quantity)
      return item ? item.quantity : 0
    },

    goToPage (page) {
      page = parseInt(page)
      const query = Object.assign({}, this.$route.query, { page: page })
      this.$router.push({ name: 'ShopIndex', query: query})
      this.currentPage = page
    },

    fetchProducts () {
      axios.get('/wp-json/wc/store/products', { withCredentials: true }).then(res => {
        console.log(res.data)
        this.products = res.data
      }).catch(e => {
        console.log(e)
      }).finally(() => {
      })           
    },

    fetchCart () {
      this.isLoading = true
      axios.get('/wp-json/wc/store/cart', { withCredentials: true }).then(res => {
        // console.log(res.data)
        this.cart = res.data
        this.updateCartCount(this.cart.items_count)
      }).catch(e => {
        console.log(e)
      }).finally(() => {
        this.isLoading = false
      })
    },

    addItemToCart (id, qty) {
      this.isLoading = true
      axios.post('/wp-json/wc/store/cart/add-item',
      { id: id , quantity: qty },
      { 
        headers: { 'Nonce': window.wc_nonce },
        withCredentials: true
      }).then(res => {
        console.log(res.data)
        this.cart = res.data
        this.updateCartCount(this.cart.items_count)
        this.showSuccessModal = true
      }).catch(e => {
        console.log(e)
      }).finally(() => {
        this.isLoading = false
      })
    },

    removeItemFromCart (id) {
      try {
        this.isLoading = true
        const key = find(this.cart.items, { 'id': parseInt(id) }).key
        axios.post('/wp-json/wc/store/cart/remove-item',
        { key: key },
        { 
          headers: { 'Nonce': window.wc_nonce },
          withCredentials: true
        }).then(res => {
          console.log(res.data)
          this.cart = res.data
          this.updateCartCount(this.cart.items_count)
          // this.showSuccessModal = true
        }).catch(e => {
          console.log(e)
        }).finally(() => {
          this.isLoading = false
        })   
      } catch (e) {
        this.isLoading = false
      }
    },

    updateItemInCart (id, qty) {
      try {
        this.isLoading = true
        const key = find(this.cart.items, { 'id': parseInt(id) }).key
        axios.post('/wp-json/wc/store/cart/update-item',
        { key: key, quantity: qty },
        { 
          headers: { 'Nonce': window.wc_nonce },
          withCredentials: true
        }).then(res => {
          console.log(res.data)
          this.cart = res.data
          this.updateCartCount(this.cart.items_count)
          this.showSuccessModal = true
        }).catch(e => {
          console.log(e)
        }).finally(() => {
          this.isLoading = false
        })   
      } catch (e) {
        this.isLoading = false
      }
    },

    updateProductsPerPage () {
      if ((window.innerWidth > 991 && window.innerWidth < 1400) || (window.innerWidth > 2100 && window.innerWidth < 2450)) {
        this.productsPerPage = 24
      } else {
        this.productsPerPage = 24
      }
    },

    setDisplayParams (params) {
      this.productsPerPage = params.productsPerPage
      this.showSku = params.showSku
      this.showSalesOnly = params.showSalesOnly
    },

    setFilterParams (params) {
      this.page = 1
      this.activeBrands = params.activeBrands
      this.activeCategories = params.activeCategories
      this.activePriceHigh = params.activePriceHigh
      this.activePriceLow = params.activePriceLow
      this.activeSearchTerm = params.activeSearchTerm
      this.activeTags = params.activeTags
    },

    toggleCategoryDescription () {
      this.showCategoryDescription = !this.showCategoryDescription
      this.categoryDescriptionHeight = this.showCategoryDescription ? this.$refs.categoryDescription.offsetHeight : 0
    },

    toggleFilter () {
      this.showFilter = !this.showFilter
    },

    updateCartCount (count) {
      const cartCountEl = document.querySelector('.cart-count')
        if (cartCountEl) {
          cartCountEl.innerText = count
          cartCountEl.classList.add('bounce-zoom')
          setTimeout(() => {
            cartCountEl.classList.remove('bounce-zoom')
          }, 1000)
        }      
    }
  }
}
</script>
<style lang="scss">
@import '../assets/scss/variables';

.shop__header-mobile {
  background-color: $purple;
  display: flex;
  // margin: 0px -15px 0;
  padding: 20px 15px;
  position: sticky;
  top: 0;
  z-index: 8999;

  .v-store__filter-toggle, .v-store__sorting {
    margin: 0;
    text-align: center;
    width: 50%;
  }

  .v-store__filter-toggle {
    color: #fff;

    i {
      padding-left: 7px;
    }
  }

  .v-store__sorting {
    display: flex;
    align-items: center;
    justify-content: center;

    i {
      color: #fff;
      font-size: 18px;
    }
  }

  .v-store__sorting select {
    -webkit-appearance: none;
    color: #fff;
    // width: 100%;
    text-align: center;
  }

  @media (min-width: $lg) {
    display: none;
  }
}

.v-store {
  min-height: 100vh; // So we can always scroll into view even with no content
  // padding-top: 50px;
  position: relative;
  width: 100%;

  &__loader {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(255, 255, 255, 0.5);
    z-index: 99999;

    i {
      color: $purple;
      font-size: 60px;
      position: absolute;
      top: 100px;
      left: 50%;
      transform: translateX(-50%);
    }
  }

  &__wrapper {
    position: relative;

    @media (min-width: $lg) {
      display: flex;
    }
  }

  main {
    background-color: #fff;
    flex-shrink: 1;
    padding: 30px 15px;
    width: 100%;

    @media (min-width: $lg) {
      padding: 30px 15px 0;
    }
  }

  &__products-title {
    color: $purple;
  }

  &__category-description-wrapper {
    overflow: hidden;
    transition: height 0.3s ease-in-out;
  }

  &__products-header {
    align-items: center;
    display: flex;
    justify-content: center;
    padding-bottom: 20px;
  }

  &__products {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    margin: 0 -30px;
    position: relative;
    padding: 0 20px;

    @media (max-width: $xl) {
      margin: 0 -15px;
    }
  }

  &__filter-toggle {
    color: $mpurple;
    font-size: 18px;
    margin-bottom: 1em;

    @media (min-width: $lg) {
      display: none;
    }
  }

  &__sorting {
    label {
      color: $mpurple;
      font-family: 'Raleway', Helvetica, sans-serif;
      font-size: 18px;
      padding-left: 10px;
    }

    select {
      background-color: transparent;
      border: 0;
      color: $mpurple;
      font-family: 'Raleway', Helvetica, sans-serif;
      font-size: 18px;
      padding-right: 10px;
    }

    &--desktop {
      @media (max-width: $lg) {
        display: none;
      }
    }
  }

  &__pagination {
    padding: 20px 0;
    text-align: center;

    &-number {
      cursor: pointer;
      display: inline-block;
      padding: 0 5px;

      &--active {
        font-weight: 800;
        text-decoration: underline;
      }
    }

    > * {
      vertical-align: middle;
    }

    div {
      margin-bottom: 10px;
    }

    button {
      background: transparent;
      border: 0;
      color: $pink;
      cursor: pointer;
      font-size: 30px;
      margin: 0 20px;

      &[disabled] {
        color: #ccc;
        cursor: auto;
      }
    }
  }
}

.v-store__product {
  flex-grow: 0;
  flex-shrink: 0;
  margin-bottom: 30px;
  padding: 0 15px;
  transition: transform 0.3s ease-in-out;
  width: 50%;

  // &:hover {
  //   transform: translateY(-5px);
  // }  

  @media (min-width: 580px) {
    width: 33.3%;
  }

  @media (min-width: 1400px) {
    width: 16.6%;
  }
}

.v-store__success-modal {
  background-color: rgba(#000, 0.5);
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999999;

  &-close {
    background: transparent;
    border: none;
    cursor: pointer;
    position: absolute;
    top: 10px;
    right: 15px;
    font-size: 28px;
    color: $purple;
    opacity: 0.5;

    &:hover, &:focus {
      opacity: 1;
    }
  }

  &-inner {
    background-color: #fff;
    box-shadow: 0px 2px 20px rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    padding: 40px 40px;
    position: relative;
    width: 500px;
    max-width: 100%;

    h2 {
      color: $purple;
      font-size: 36px;
      font-weight: 900;
      margin-bottom: 30px;
      text-align: center;
      width: 100%;
    }

    .button {
      margin: 5px;
    }
  }
}

// Checkbox
.v-store__filters {
  /* Base for label styling */
  [type="checkbox"]:not(:checked),
  [type="checkbox"]:checked {
    position: absolute;
    left: 0;
    opacity: 0.01;
  }
  [type="checkbox"]:not(:checked) + label,
  [type="checkbox"]:checked + label {
    position: relative;
    padding-left: 2.3em;
    font-size: 14px;
    line-height: 2;
    cursor: pointer;
  }

  /* checkbox aspect */
  [type="checkbox"]:not(:checked) + label:before,
  [type="checkbox"]:checked + label:before {
    content: '';
    position: absolute;
    left: 0;
    top: 5px;
    width: 1.4em;
    height: 1.4em;
    border: 2px solid $pink;
    background: #fff;
    border-radius: 3px;
    box-shadow: inset 0 1px 3px rgba(0,0,0, .1), 0 0 0 rgba($purple, .2);
    -webkit-transition: all .275s;
        transition: all .275s;
  }

  /* checked mark aspect */
  [type="checkbox"]:not(:checked) + label:after,
  [type="checkbox"]:checked + label:after {
    content: '✕';
    position: absolute;
    top: calc(.55em + 5px);
    left: .13em;
    font-size: 1.375em;
    color: $pink;
    line-height: 0;
    -webkit-transition: all .2s;
        transition: all .2s;
  }

  /* checked mark aspect changes */
  [type="checkbox"]:not(:checked) + label:after {
    opacity: 0;
    -webkit-transform: scale(0) rotate(45deg);
        transform: scale(0) rotate(45deg);
  }

  [type="checkbox"]:checked + label:after {
    opacity: 1;
    -webkit-transform: scale(1) rotate(0);
        transform: scale(1) rotate(0);
  }

  /* Disabled checkbox */
  [type="checkbox"]:disabled:not(:checked) + label:before,
  [type="checkbox"]:disabled:checked + label:before {
    box-shadow: none;
    border-color: #bbb;
    background-color: #e9e9e9;
  }

  [type="checkbox"]:disabled:checked + label:after {
    color: #777;
  }

  [type="checkbox"]:disabled + label {
    color: #aaa;
  }

  /* Accessibility */
  [type="checkbox"]:checked:focus + label:before,
  [type="checkbox"]:not(:checked):focus + label:before {
    box-shadow: inset 0 1px 3px rgba(0,0,0, .1), 0 0 0 3px rgba($purple, .2);
  }  

  .pointer {
    cursor: pointer;
  }
}
</style>